<template>
  <article class="layout-section layout-grid -smaller">
    <section
      v-for="({ name, title, info, image }, index) in $t('team.members')"
      :key="name"
      v-appear="{ threshold: 0, offset: 0, delay: getDelay(index) }"
      class="layout-grid__item"
    >
      <figure
        class="layout-grid__figure -profile"
        :style="{ '--image': `url('${image || '/images/team/thumbnail.png'}')` }"
        @click="currentIndex = index"
      />

      <div class="layout-grid__content">
        <h4 class="layout-grid__title">{{ name }}</h4>
        <h6 class="layout-grid__subtitle -accent">{{ title }}</h6>
        <p>{{ info }}</p>
      </div>
    </section>

    <OverlayModal :is-open="!!currentMember" v-bind="currentMember" @close="currentIndex = null" />
  </article>
</template>

<script>
export default {
  name: 'TeamIndex',
  data() {
    return {
      currentIndex: null
    }
  },
  computed: {
    currentMember() {
      if (this.currentIndex === null) return null
      const { name, title, info, description } = this.$t('team.members')[this.currentIndex]

      return {
        title: name,
        subtitle: `${title} - ${info}`,
        content: description
      }
    }
  },
  methods: {
    getDelay(index) {
      const delay = (index * 50) % 200
      return index < 4 ? [this.$scroll, 900 + delay, delay] : delay
    }
  }
}
</script>
